import UploadImage from '@/components/upload-image/index.vue';
import Service from '../../project.service';
import { errorMessage, successMessage } from '@/utils/message.js';

export default {
  components: {
    UploadImage
  },
  data() {
    const validateInputValue = (rule, value, callback) => {
      if (this.ruleForm.certificate.inputValue) {
        callback();
      } else {
        callback(new Error('请上传付款凭证'));
      }
    };
    return {
      iframeUrl: '',
      id: '',
      activeNav: 1,
      detail: {},
      ruleForm: {
        certificate: {
          filePaths: [],
          inputValue: null
        },
        remark: ''
      },
      rules: {
        inputValue: [
          { required: true, validator: validateInputValue, trigger: 'change' }
        ]
      },
      actionStatus: 'init',
      bidSignRelationId: ''
    };
  },
  created () {
    // 后端防双击
    this.$store.dispatch('generatorClickToken');
    this.id = this.$route.query.id;
    this.bidSignRelationId = this.$route.query.bidSignRelationId;
    if (this.id) {
      this.getMarginPaymentDetail();
    }
  },
  methods: {
    changeActiveNav (key) {
      this.activeNav = key;
      // 线上支付
      if(Number(key) === 2) {
        let paymentParams = {
          projectBidCode: this.detail.projectBidCode,
          amount: this.detail.depositResForm.depositAmount,   // 交易金额
          bidNo: this.detail.projectBidCode, // 标的编号
          cashierType: 'PC',   // 收银台类型(PC端/移动端)
          transactionType: 2, // 2 保证金； 10 合同款、履约保证金；12 工程质保金
          acctNo: this.detail.payerAccResForm.accNo // 付款方账号
        };
        this.$store.dispatch('onlinePayment', paymentParams).then((res) => {
          console.log(res, '========线上支付');
          this.iframeUrl = res.data.bankNoURL;
        }, error => {
          if (error && error.reason) {
            errorMessage(error.reason);
          }
        });
      }
    },
    getMarginPaymentDetail() {
      Service.getOrderDetaiByDeposit({
        transactionType: 2,
        bidId: this.id
      }).then(res => {
        if (res && res.code === '0') {
          this.detail = res && res.data;
        }
      });
    },
    uploadImage (event) {
      this.ruleForm.certificate.filePaths = event;
      if (event.length) {
        this.ruleForm.certificate.inputValue = event.length;
      } else {
        this.ruleForm.certificate.inputValue = null;
      }
    },
    previousStep () {
      this.$router.back();
    },
    // 线下支付
    test() {
      if (this.actionStatus === 'ongoing') {return;}
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$confirm('请确认是否转款？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit();
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },
    submit() {
      if (this.actionStatus === 'ongoing') {return;}
      this.actionStatus = 'ongoing';
      Service.paymentBid({
        paymentMethod: 2,
        purchaseId: this.id,
        remark: this.ruleForm.remark,
        projectType: 1,
        transactionAmount: this.detail.depositResForm && this.detail.depositResForm.depositAmount,
        transactionNo: this.detail.depositResForm && this.detail.depositResForm.tradeNo,
        transactionType: 2,
        urls: this.ruleForm.certificate.filePaths.map(item => item.sourceImgUrl),
        bidId: this.detail.depositResForm && this.detail.depositResForm.bidId,
        bidSignRelationId: this.bidSignRelationId
      }).then(res => {
        if (res && res.code === '0') {
          this.actionStatus = 'success';
          successMessage('提交成功');
          this.previousStep();
        } else if (res && res.reason) {
          this.actionStatus = 'failed';
          errorMessage(res && res.reason);
        } else {
          this.actionStatus = 'failed';
          errorMessage('提交失败');
        }
      }, (error) => {
        this.actionStatus = 'failed';
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('提交失败');
        }
      });
    }
  }
};
